import { render } from "./Unit4GapReport.vue?vue&type=template&id=5b6525e0"
import script from "./Unit4GapReport.vue?vue&type=script&lang=js"
export * from "./Unit4GapReport.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__